/* Lighting Reimagined — product page behaviour
   1. Detail tabs (lr-product-tabs section)
   2. "Complete the look" bundle selection (lr-complete-the-look section)
   Both are delegated so they survive Section Rendering API re-renders. */

(function () {
  'use strict';

  /* ---------------------------------------------------------------- Tabs */

  function selectTab(tab) {
    var list = tab.closest('[data-lr-tabs]');
    if (!list) return;

    list.querySelectorAll('[data-lr-tab]').forEach(function (button) {
      var selected = button === tab;
      button.setAttribute('aria-selected', selected ? 'true' : 'false');
      button.setAttribute('tabindex', selected ? '0' : '-1');
    });

    list.querySelectorAll('[data-lr-tab-panel]').forEach(function (panel) {
      panel.hidden = panel.id !== tab.getAttribute('aria-controls');
    });
  }

  document.addEventListener('click', function (event) {
    var tab = event.target.closest('[data-lr-tab]');
    if (tab) selectTab(tab);
  });

  document.addEventListener('keydown', function (event) {
    var tab = event.target.closest('[data-lr-tab]');
    if (!tab) return;
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;

    var tabs = Array.prototype.slice.call(
      tab.closest('[data-lr-tabs]').querySelectorAll('[data-lr-tab]')
    );
    var next = tabs[tabs.indexOf(tab) + (event.key === 'ArrowRight' ? 1 : -1)];
    if (!next) next = event.key === 'ArrowRight' ? tabs[0] : tabs[tabs.length - 1];

    event.preventDefault();
    selectTab(next);
    next.focus();
  });

  /* ------------------------------- Snippet-backed tabs: variant switching */
  /* product-info.liquid and products-metadata.liquid print one list per variant
     (`.var-<id>`) and hide all but the selected one inline. Their own
     `{% javascript %}` blocks poll the URL, but that tag is only bundled for
     sections — so drive it from the variant-change event instead. */

  function showVariantLists(variantId) {
    if (!variantId) return;
    document
      .querySelectorAll('.lr-tabs__snippet .variant-inf, .lr-tabs__snippet .variant-meta')
      .forEach(function (list) {
        list.style.display = list.classList.contains('var-' + variantId) ? '' : 'none';
      });
  }

  if (typeof subscribe === 'function') {
    subscribe('variant-change', function (event) {
      var variant = event && event.data && event.data.variant;
      if (variant) showVariantLists(variant.id);
    });
  }

  /* ------------------------------------------ Thumbnail column scrolling */
  /* Dawn's slider-component only scrolls horizontally, so the vertical
     thumbnail column gets its own controls. */

  function thumbColumns() {
    return document.querySelectorAll('.lr-pdp .thumbnail-slider');
  }

  function syncThumbNav(column) {
    var list = column.querySelector('.thumbnail-list');
    var buttons = column.querySelectorAll('[data-lr-thumb-scroll]');
    if (!list || !buttons.length) return;

    var maxScroll = list.scrollHeight - list.clientHeight;
    var scrollable = maxScroll > 2;

    buttons.forEach(function (button) {
      button.hidden = !scrollable;
      if (!scrollable) {
        button.disabled = true;
        return;
      }
      button.disabled = Number(button.getAttribute('data-lr-thumb-scroll')) < 0
        ? list.scrollTop <= 1
        : list.scrollTop >= maxScroll - 1;
    });
  }

  function syncAllThumbNavs() {
    thumbColumns().forEach(syncThumbNav);
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-lr-thumb-scroll]');
    if (!button) return;

    var column = button.closest('.thumbnail-slider');
    var list = column && column.querySelector('.thumbnail-list');
    if (!list) return;

    event.preventDefault();

    var item = list.querySelector('.thumbnail-list__item');
    var step = item ? item.offsetHeight + 16 : 112;
    var pageSize = Math.max(1, Math.floor(list.clientHeight / step)) * step;

    list.scrollTop += Number(button.getAttribute('data-lr-thumb-scroll')) * pageSize;
  });

  /* scroll doesn't bubble — listen in the capture phase */
  document.addEventListener(
    'scroll',
    function (event) {
      var list = event.target;
      if (!list.classList || !list.classList.contains('thumbnail-list')) return;
      var column = list.closest('.thumbnail-slider');
      if (column) syncThumbNav(column);
    },
    true
  );

  window.addEventListener('resize', syncAllThumbNavs);
  window.addEventListener('load', syncAllThumbNavs);
  document.addEventListener('shopify:section:load', syncAllThumbNavs);

  /* the gallery is re-rendered on variant change, so re-sync when it changes */
  if (window.MutationObserver && document.querySelector('.lr-pdp')) {
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        syncAllThumbNavs();
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  syncAllThumbNavs();

  /* ------------------------------------------------- Complete the look */

  function formatMoney(cents, currency, locale) {
    try {
      return new Intl.NumberFormat(locale || 'en-US', {
        style: 'currency',
        currency: currency || 'USD'
      }).format(cents / 100);
    } catch (error) {
      return (cents / 100).toFixed(2);
    }
  }

  function refreshBundle(root) {
    var checked = Array.prototype.slice.call(
      root.querySelectorAll('[data-lr-ctl-item]:checked')
    );
    var total = checked.reduce(function (sum, input) {
      return sum + parseInt(input.getAttribute('data-price'), 10) * 1;
    }, 0);

    var count = root.querySelector('[data-lr-ctl-count]');
    var value = root.querySelector('[data-lr-ctl-value]');
    var submit = root.querySelector('[data-lr-ctl-submit]');

    if (count) {
      count.textContent = checked.length === 1
        ? '1 item selected'
        : checked.length + ' items selected';
    }
    if (value) {
      value.textContent = formatMoney(
        total,
        root.getAttribute('data-currency'),
        root.getAttribute('data-locale')
      );
    }
    if (submit) submit.disabled = checked.length === 0;
  }

  document.addEventListener('change', function (event) {
    var input = event.target.closest('[data-lr-ctl-item]');
    if (!input) return;
    var root = input.closest('[data-lr-ctl]');
    if (root) refreshBundle(root);
  });

  document.addEventListener('click', function (event) {
    var submit = event.target.closest('[data-lr-ctl-submit]');
    if (!submit) return;

    var root = submit.closest('[data-lr-ctl]');
    if (!root) return;

    var items = Array.prototype.slice
      .call(root.querySelectorAll('[data-lr-ctl-item]:checked'))
      .map(function (input) {
        return { id: parseInt(input.value, 10), quantity: 1 };
      });
    if (!items.length) return;

    event.preventDefault();
    submit.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (response) {
        if (!response.ok) return response.json().then(function (error) { throw error; });
        return response.json();
      })
      .then(function () {
        root.querySelectorAll('[data-lr-ctl-item]:checked').forEach(function (input) {
          input.checked = false;
        });
        refreshBundle(root);
        var opener = document.querySelector('[data-cart-open]');
        if (opener) opener.click();
      })
      .catch(function (error) {
        alert((error && error.description) || 'Unable to add these items to your cart.');
      })
      .finally(function () {
        refreshBundle(root);
      });
  });

  document.querySelectorAll('[data-lr-ctl]').forEach(refreshBundle);
})();